import { ValidationException } from "../BaseForm";

interface ValidationExceptionResponse {
  response: { body: ValidationException };
}

export function isValidationException(error: any): error is ValidationExceptionResponse {
  return error?.response?.body?.clazz === "ValidationException";
}
